// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-a1e4eee4] {\n  cursor: pointer;\n}\n[data-v-a1e4eee4] .el-input__inner {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
